
// export const classCharContainerHeightDesktop = `lap:h-[536px] des:h-[590px] `
// export const classCharContainerWidth = ` w-[400px] mob:w-[480px] tab:w-[510px] lap:w-[536px] des:w-[590px] `
// export const classCharPieContainerHeight = `h-[220px] mob:h-[320px] tab:h-[480px] lap:h-[506px] des:h-[560px] 
//                                             w-[220px] mob:w-[320px] tab:w-[480px] lap:w-[506px] des:w-[560px]`

import { toFormatPrice } from "../../utils/utils";

export const classCharContainerHeight = ` h-[400px] mob:h-[480px] tab:h-[510px] lap:h-[536px] des:h-[590px] `
export const classCharWithDoughtnutContainerHeight = ` h-[400px] mob:h-[480px] tab:h-[510px] lap:h-[700px] des:h-[700px] `
export const classCharDoughnutContainerHeight = `h-[300px] mob:h-[380px] tab:h-[480px] lap:h-[506px] des:h-[560px] 
                                            w-[300px] mob:w-[380px] tab:w-[480px] lap:w-[506px] des:w-[560px]`


export const isData = (arr: number[]) => {
    const is = !!arr.filter(i => i !== 0).length
    return is
}

export const topLabels = (fixedCount = 2) => {
    return {
        id: "topLabels",
        afterDatasetsDraw: function (chart: any, args: any, pluginOptions: any) {
            const { ctx, scales: { x, y } } = chart
            if (!!chart.data.datasets.length) {
                chart.data.datasets[0].data.forEach((_: any, index: any) => {
                    const datasetArr: any[] = []
                    chart.data.datasets.forEach((dataset: any) => {
                        datasetArr.push(dataset.data[index])
                    })
                    const sum = datasetArr.reduce((prev, next) => prev + next, 0)
                    const sumFormat = fixedCount ? toFormatPrice(sum, fixedCount) : sum.toFixed()
                    if (!!sum) {
                        ctx.textAlign = 'center'
                        ctx.font = 'bold 12px Inter'
                        ctx.fillStyle = '#2D2B32'
                        ctx.fillText(sumFormat, x.getPixelForValue(index), chart.getDatasetMeta(0).data[index].y - 14) // 
                    }
                })
            }

        }
    };
}

export const isShowInLegend = (legend: any[], key: any) => {
    const isshow = legend.find((i: any) => i.key === key)?.show
    return isshow
}


// COMPARISON
export const monthFormatView = 'MMMM YYYY'
export const monthFormatFilter = 'MM-YYYY'
export const monthFormatChange = 'month'

export const dayFormatView = 'DD MMMM YYYY'
export const dayFormatFilter = 'DD-MM-YYYY'
export const dayFormatChange = 'day'


export const SALDO_GRAPH_ID = "js-saldo-graph"

export const TAB_0_GRAPH_1_ID = "js-tab-0-period1-graph"
export const TAB_0_GRAPH_2_ID = "js-tab-0-period2-graph"
export const TAB_1_GRAPH_1_ID = "js-tab-1-period1-graph"
export const TAB_1_GRAPH_2_ID = "js-tab-1-period2-graph"
export const TAB_2_GRAPH_1_ID = "js-tab-2-period1-graph"
export const TAB_2_GRAPH_2_ID = "js-tab-2-period2-graph"